import { tuple } from '../../_util/type';
export var PlaceMent = tuple('top', 'bottom');